import { ArrowForwardIos, PlayArrow } from "@mui/icons-material";
import React, { memo } from "react";

import { Handle } from "react-flow-renderer";

export default memo(({ data, isConnectable }) => {
  return (
    <div
      style={{
        backgroundColor: "#ffffff",
        padding: "12px 18px",
        borderRadius: "9px",
        boxShadow: "0 8px 18px rgba(15, 23, 42, 0.10)",
        border: "1px solid #e5e7eb",
        minWidth: 152
      }}
    >
      <div
        style={{
          color: "#111827",
          fontSize: "15px",
          fontWeight: 600,
          flexDirection: "row",
          display: "flex",
          alignItems: "center",
          gap: 8
        }}
      >
        <PlayArrow
          sx={{
            width: "22px",
            height: "22px",
            color: "#10b981",
            backgroundColor: "rgba(16, 185, 129, 0.10)",
            borderRadius: "6px",
            padding: "4px"
          }}
        />
        <div>
          Início
        </div>
      </div>
      <Handle
        type="source"
        position="right"
        id="a"
        style={{
          background: "#14b8a6",
          width: "9px",
          height: "9px",
          top: "50%",
          right: "-5px",
          cursor: 'pointer'
        }}
        isConnectable={isConnectable}
      >
        <ArrowForwardIos
          sx={{
            color: "#ffff",
            width: "10px",
            height: "10px",
            marginLeft: "2.9px",
            marginBottom: "1px",
            pointerEvents: 'none'
          }}
        />
      </Handle>
    </div>
  );
});
